import { render, staticRenderFns } from "./hotel_clock.vue?vue&type=template&id=74b38c0a&"
import script from "./hotel_clock.vue?vue&type=script&lang=js&"
export * from "./hotel_clock.vue?vue&type=script&lang=js&"
import style0 from "./hotel_clock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports